import get from 'lodash/get';
import actionTypes, {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from './actionTypes';

const initialState = {
  quotes: {
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
    },
    total: 0,
    sorter: {
      key: '',
      value: '', // desc ||asc
    },
    loading: false,
    error: null,
  },
  quote: {
    data: null,
    loading: false,
    error: null,
  },
  onHoldLogs: {
    data: [],
    total: 0,
    loading: false,
    error: null,
  },
  quoteMessage: {
    data: [],
    loading: false,
    error: null,
  },
  jobMessage: {
    data: [],
    loading: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    // #region GET_QUOTE_DETAIL
    case asyncActionTypeRequest(actionTypes.GET_QUOTE_DETAIL): {
      return {
        ...state,
        quote: {
          ...state.quote,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_QUOTE_DETAIL): {
      return {
        ...state,
        quote: {
          ...state.quote,
          loading: false,
          data: get(action, 'response.data', {}) || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_QUOTE_DETAIL): {
      return {
        ...state,
        quote: {
          ...state.quote,
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    // #endregion
    // #region GET_QUOTES
    case asyncActionTypeRequest(actionTypes.GET_QUOTES): {
      return {
        ...state,
        quotes: {
          ...state.quotes,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_QUOTES): {
      return {
        ...state,
        quotes: {
          ...state.quotes,
          total: get(action, 'response.data.pagination.total', 0),
          loading: false,
          data: get(action, 'response.data.list', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_QUOTES): {
      return {
        ...state,
        quotes: {
          ...state.quotes,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case actionTypes.CHANGE_PARAMS_QUOTES: {
      return {
        ...state,
        quotes: {
          ...state.quotes,
          pagination: {
            ...action.payload.pagination,
          },
          sorter: {
            ...action.payload.sorter,
          },
        },
      };
    }
    // #endregion

    case asyncActionTypeRequest(actionTypes.GET_ON_HOLD_LOGS): {
      return {
        ...state,
        onHoldLogs: {
          ...state.onHoldLogs,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_ON_HOLD_LOGS): {
      return {
        ...state,
        onHoldLogs: {
          ...state.onHoldLogs,
          loading: false,
          data: get(action, 'response.data.list', []) || [],
          total: get(action, 'response.data.pagination.total', 0),
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_ON_HOLD_LOGS): {
      return {
        ...state,
        onHoldLogs: {
          ...state.onHoldLogs,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }

    case asyncActionTypeRequest(actionTypes.GET_QUOTE_MESSAGE): {
      return {
        ...state,
        quoteMessage: {
          ...state.quoteMessage,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_QUOTE_MESSAGE): {
      return {
        ...state,
        quoteMessage: {
          ...state.quoteMessage,
          loading: false,
          data: get(action, 'response.data', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_QUOTE_MESSAGE): {
      return {
        ...state,
        quoteMessage: {
          ...state.quoteMessage,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }

    case asyncActionTypeRequest(actionTypes.GET_JOB_MESSAGE): {
      return {
        ...state,
        jobMessage: {
          ...state.jobMessage,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_JOB_MESSAGE): {
      return {
        ...state,
        jobMessage: {
          ...state.jobMessage,
          loading: false,
          data: get(action, 'response.data', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_JOB_MESSAGE): {
      return {
        ...state,
        jobMessage: {
          ...state.jobMessage,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }

    default:
      return state;
  }
};
